export function defaultGroupState ({
  exam = null,
  educationGroup = null,
  student = null,
  independentEstimateParticipantsNumber = null,
  groupStateId = 0
}) {
  return {
    education_group: {
      guid: educationGroup
    },
    item: null,
    student: student,
    independent_estimate_participants_number: independentEstimateParticipantsNumber,
    id: groupStateId++
  }
}
